import { render, staticRenderFns } from "./diapositiva-6.vue?vue&type=template&id=7bc20254&scoped=true&"
var script = {}
import style0 from "./diapositiva-6.vue?vue&type=style&index=0&id=7bc20254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc20254",
  null
  
)

export default component.exports